import { axiosInstancePlano } from "../../../../core/api/planoAxios";
import { IDisciplineSubject } from "../../model/disciplineSubjects";

export const getDisciplineSubjects = async (cronogramaId: string, disciplina: string): Promise<IDisciplineSubject[]> => {
  try {
    const { data } = await axiosInstancePlano.get(`/cronograma/conteudo/assuntos/${cronogramaId}/${disciplina}`);

    return data;
  } catch (error: any) {
    throw new Error(error.response.data.message);
  }
};

export const addNewSubjectToSchedule = async (cronogramaId: string, date: Date, assuntos: string[]) => {
  try {
    const { data } = await axiosInstancePlano.post(`/cronograma/conteudo/adicionar/${cronogramaId}`, {
      subjectsId: assuntos,
      data: date.toISOString()
    });

    return data;
  } catch (error: any) {
    throw new Error(error.response.data.message);
  }
}

